import React from "react";

import { SectionHeading, SectionMainWrapper, } from "../../Styles/style";

import styled from "@emotion/styled";
import { Container, Grid, useTheme } from "@mui/material";
import Baby from "../../../assets/images/baby.png"
import pulsec from "../../../assets/images/pulsec.png"
import pulsex from "../../../assets/images/pulsex.png"
import dex from "../../../assets/images/dex.png"

const VideoBK = styled.img`
  width: 100%;
  height: auto;
  max-width: 500PX;
  @media screen and (max-width:899px){
  padding: 50px 0;
}
`;
const GridHEading = styled(Grid)`
padding: 50px 0;
display: flex;
align-items: center;
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const GridVideo = styled(Grid)`
/* mix-blend-mode: lighten; */
`;
const Grids = styled.div`
display:flex;
justify-content:center;
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;

@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "150PX")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const Div = styled.div`
 background-color:#000;
 display:flex;
 align-items:center;
 justify-content:center;
 border-radius:50px;
 padding:15px 250px;
 gap:20px;
 position:absolute;
 bottom:-20px;
 @media screen and (max-width:899px){
   position:unset;
   bottom:0px;
 padding:15px 150px;
 }
 @media screen and (max-width:529px){
 padding:15px 160px;
 }
 @media screen and (max-width:399px){
 padding:15px 130px;
 }
`
const BuyNow = styled.a`
clip-path: polygon(9% 0, 92% 0, 100% 50%, 90% 100%, 10% 100%, 0% 50%);
font-family:"P-SB";
background: 
    linear-gradient(93deg, #FFDC00,#E58E2F,#DB2D72,#DB2D72, #FF00FF);
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 5px;
padding: 8px 50px;
margin-right: 15px;
@media screen and (max-width:499px){
  padding: 8px 20px;

}

`
const Section1_Header = () => {
  const theme = useTheme()
  return (
    <>
      <SectionMainWrapper p="0rem 0" id="home">
        <Container maxWidth="xl">

          <GridHEading container >

            <GridImage xs={12} md={6}>
              <SectionHeading
                maxWidth="90%"
                p="60px 0"
                m="0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0"
              >
                Baby Hex:<br/>
                Secure Investments
                On The Pulse<br/>
                Network
              </SectionHeading>

              <div data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="500"
                data-aos-offset="0"
              >

                <BuyNow
                  href="https://app.pulsex.com/swap?outputCurrency=0x2Dc74A935bBEBc793D79162736066Af829D2ba9A"
                  target="_blank">
                  Buy Now
                </BuyNow>
                <BuyNow
                  data-aos="flip-up"
                  data-aos-easing="ease-in"
                  data-aos-delay="700"
                  data-aos-duration="700"
                  data-aos-offset="0"
                  href="https://www.dextools.io/app/en/pulse/pair-explorer/0x42936a5edf811f94f1ddeb7d7080617e6452bcef"
                  target="_blank">
                  View Chart
                </BuyNow>
              </div>

            </GridImage>
            <GridVideo
              xs={12}
              md={6}
              data-aos="flip-down"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="700"
              data-aos-offset="0"
            >
              <VideoBK src={Baby} />
            </GridVideo>
          </GridHEading>
          <Grids >
            <Div>
              <JOiningLinks src={pulsec}  data-aos="flip-up"
                  data-aos-easing="ease-in"
                  data-aos-delay="400"
                  data-aos-duration="700"
                  data-aos-offset="0"
                  href="/"
                  target="_blank"/>
              <JOiningLinks src={pulsex}  data-aos="flip-up"
                  data-aos-easing="ease-in"
                  data-aos-delay="500"
                  data-aos-duration="700"
                  data-aos-offset="0"
                  href="/"
                  target="_blank"/>
              <JOiningLinks src={dex}   data-aos="flip-up"
                  data-aos-easing="ease-in"
                  data-aos-delay="600"
                  data-aos-duration="700"
                  data-aos-offset="0"
                  href="/"
                  target="_blank"/>


            </Div>
          </Grids>
        </Container>
      </SectionMainWrapper>

    </>
  );
};

export default Section1_Header;
